
@if (isOpen()) {
  <div (click)="onBackdropClick($event)" class="fixed inset-0 bg-black/80 flex items-center justify-center z-50 backdrop-blur-sm p-4 animate-fade-in">
    <div class="bg-slate-900 rounded-2xl shadow-2xl w-full max-w-lg border border-slate-700 overflow-hidden" (click)="$event.stopPropagation()">
      
      <div class="p-6 border-b border-slate-800 bg-slate-950 flex justify-between items-center">
        <h2 class="text-xl font-bold text-white flex items-center gap-2">
            <i class="fa-solid fa-user-plus text-purple-500"></i> Invite Platform Staff
        </h2>
        <button (click)="onClose()" class="text-slate-500 hover:text-white transition-colors"><i class="fa-solid fa-times text-xl"></i></button>
      </div>

      <div class="p-6 space-y-6">
        @if (inviteLink()) {
            <div class="text-center space-y-4 animate-fade-in">
                <div class="p-4 bg-emerald-900/20 border border-emerald-500/50 rounded-xl text-left">
                    <p class="font-bold text-emerald-400 mb-1">Link Generated!</p>
                    <p class="text-xs text-slate-400">Share this unique link with the new team member. They will be registered as a global platform staff.</p>
                </div>
                
                <div class="relative group">
                    <input type="text" [value]="inviteLink()" readonly class="w-full bg-slate-950 border border-slate-700 rounded-lg p-3 text-xs text-slate-300 font-mono pr-12 focus:outline-none">
                    <button (click)="copyLink()" class="absolute right-2 top-2 p-1.5 text-purple-400 hover:text-purple-300 transition-colors bg-slate-900 rounded border border-slate-700">
                        <i class="fa-regular fa-copy"></i>
                    </button>
                </div>
                
                <button (click)="onClose()" class="w-full py-3 bg-purple-600 hover:bg-purple-500 text-white font-bold rounded-xl transition-all shadow-lg">Done</button>
            </div>
        } @else {
            <form [formGroup]="inviteForm" (ngSubmit)="sendInvite()" class="space-y-6">
                <div>
                    <label class="block text-xs font-bold text-slate-500 uppercase mb-2">Staff Email Address</label>
                    <input type="email" formControlName="email" placeholder="staff@platform.com" 
                           class="w-full bg-slate-950 border border-slate-700 rounded-xl p-3 text-white focus:ring-2 focus:ring-purple-500 transition-all outline-none">
                </div>

                <div>
                    <label class="block text-xs font-bold text-slate-500 uppercase mb-3">Global Platform Role</label>
                    <div class="space-y-2">
                        @for (role of roles; track role.id) {
                            <label class="flex items-start gap-3 p-3 rounded-xl border border-slate-800 bg-slate-950/50 hover:bg-slate-800 transition-all cursor-pointer group"
                                   [class.border-purple-500]="inviteForm.get('role')?.value === role.id"
                                   [class.bg-purple-900_10]="inviteForm.get('role')?.value === role.id">
                                <input type="radio" formControlName="role" [value]="role.id" class="mt-1 w-4 h-4 text-purple-600 bg-slate-900 border-slate-700 focus:ring-purple-500 focus:ring-offset-slate-900">
                                <div class="flex-grow">
                                    <div class="text-sm font-bold text-slate-200 group-hover:text-white transition-colors">{{ role.label }}</div>
                                    <div class="text-[10px] text-slate-500 leading-tight mt-0.5">{{ role.desc }}</div>
                                </div>
                            </label>
                        }
                    </div>
                </div>

                <div class="pt-4 flex gap-3">
                    <button type="button" (click)="onClose()" class="flex-1 py-3 bg-slate-800 hover:bg-slate-700 text-slate-300 font-bold rounded-xl transition-colors">Cancel</button>
                    <button type="submit" [disabled]="inviteForm.invalid || isSubmitting()" 
                            class="flex-[2] py-3 bg-purple-600 hover:bg-purple-500 text-white font-bold rounded-xl transition-all shadow-lg shadow-purple-900/20 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                        @if(isSubmitting()) { <i class="fa-solid fa-circle-notch animate-spin"></i> }
                        @else { <i class="fa-solid fa-paper-plane"></i> }
                        Generate Invite Link
                    </button>
                </div>
            </form>
        }
      </div>
      
    </div>
  </div>
}
